import Vue from 'vue';
import CategoriesComponent from '~/components/home/mainpage-categories-component.vue';
import { getCookie, setCookie} from '../utils/cookie-manager.js'

DM.Module.Categories = ((DM) => {
    const SELECTOR = '.js-main-categories';
    const ELEMENT = document.querySelector(SELECTOR);
    const componentType = {
        0: 'dm-vertical-tile',
        1: 'dm-two-tiles',
        2: 'dm-two-tiles-and-horizontal',
        3: 'dm-horizontal-tile-and-two',
    };

    class Categories {
        constructor(element) {
            const categories = this.getData();
            this.createComponent(element, categories);
        }
        getData() {
            const mainPageData = DM.Boot.MainPage;
            const female = mainPageData.mainPageCategoriesFemale.map((group) => {
                group.component = componentType[group.type];
                return group;
            });
            const male = mainPageData.mainPageCategoriesMale.map((group) => {
                group.component = componentType[group.type];
                return group;
            });
            const child = mainPageData.mainPageCategoriesChild.map((group) => {
                group.component = componentType[group.type];
                return group;
            });
            const categories = [
                female,
                male,
                child,
            ];
            return categories;
        }

        createComponent(element, categories) {
            const defaultActiveGender = 0;
            const genders = {
                0: {
                    name: 'Kobieta',
                    link: '/kobieta'
                },
                1: {
                    name: 'Mężczyzna',
                    link: '/mezczyzna'
                },
                2: {
                    name: 'Dziecko',
                    link: '/dziecko'
                },
            };

            return new Vue({
                name: 'dm-categories',
                el: element,
                components: {
                    'dm-categories': CategoriesComponent
                },
                template: '<dm-categories v-on:changeTab="changeTab" :categories="categories" :genders="genders" :currentCategoryGroup="activeTab"></dm-categories>',
                data: {
                    categories: categories,
                    genders,
                    activeTab: 0,
                },
                created() {
                    this.activeTab = parseInt(getCookie('dm_category_gender')) || defaultActiveGender;
                },
                methods: {
                    changeTab(gender) {
                        this.activeTab = gender;
                        setCookie('dm_category_gender', this.activeTab, 365);
                    }
                }
            });
        }
    }
    if (ELEMENT) {
        new Categories(ELEMENT);
    }
})(window.DM);
